import { useColorScheme } from '@/hooks/useColorScheme';
import { Color, colors } from '@/lib/colors';

export const useColor = (color: Color) => {
  const { colorScheme } = useColorScheme();
  return colors[colorScheme][color];
};
